// extracted by mini-css-extract-plugin
export var container = "_5d-0";
export var fallback = "_5d-5";
export var fallbackIcon = "_5d-6";
export var hidden = "_5d-2";
export var image = "_5d-3";
export var loaded = "_5d-4";
export var placeholder = "_5d-1";